<template>
<section class="ui-section bsa-section">
    <div class="ui-max-width">
        <div class="txt-center">
            <div class="ui-head">
                <h3 v-html="$t('bsa_head')"></h3>
            </div>
        </div>
        <div class="ui-ts-text-wrap">
            <p>{{$t('bsa_p') }}</p>
            <div style="margin-top:40px">
                <img src="~@/assets/images/bsa1.png" alt="BelSar Admin" class="micro-inj-img img-responsive">
                <span class="bsd-micro-label">{{ $t('bsa_label1')}}</span>
            </div>
            <div>
                <img src="~@/assets/images/bsa2.png" alt="BelSar Admin" class="img-responsive">
                <span class="bsd-laser-label">{{ $t('bsa_label2')}}</span>
            </div>
        </div>
    </div>
</section>
</template>

<script>
export default {
 components: {}
}
</script>


<style lang="scss" scoped>
/*EDIT COLOURS HERE*/

.micro-inj-img{
    @media screen and (min-width: 767px) {
        width: 60%;
    }
}
.bsd-micro-label, .bsd-laser-label{
    padding: 8px 16px;
    color: white;
    position: relative;
    bottom: 70px;
    display: inline-block;


    @media screen and (min-width: 767px) {
        min-width: 300px;
    }

}

.bsd-micro-label{
    background: $accenttwo-color;;
}

.bsd-laser-label{
    background: $primary-color;
}
.bsa-section {
    background-color: white;
    padding: 40px 0;
}
.ui-ts-heading {
    color: #4e5157;
}
.img-responsive {
    max-width: 100%;
    height: auto;
}

.ui-ts-heading span {
    color: #39a8e3;
}

.ui-ts-subheading {
    color: #39a8e3;
}

.ui-ts-subheading {
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0.005em;
    text-align: left;
    margin-bottom: 8px;
}

.ui-ts-text-wrap {
    margin-left: 0;
    text-align: center;
    padding: 0 16px;

    img{
        margin: 0 auto;
        display: block;
        margin-bottom: 20px;
    }
}

.ui-ts-ul {
    list-style: disc;
    margin-top: 12px;
    margin-bottom: 12px;
}

.ui-ts-ol {
    list-style: decimal;
    margin-top: 12px;
    margin-bottom: 12px;
}

.ui-ts-li {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 6px;
    padding-left: 8px;
}
</style>
